import {
    Button, Card,
    CardActions,
    CardContent,
    CardHeader,
    Divider,
    Typography
} from "@material-ui/core";
import React from "react";
import sourceMap from 'source-map-js';
import { getUser } from 'src/utils/Common';
import axios from 'src/utils/axios';
import logger from 'src/utils/logger';

// Hata: makeStyles class tabanlı bileşenlerde (ErrorBoundary) doğrudan kullanılamaz, 
// ancak render içinde veya dışarıda stil objesi olarak kullanılabilir.

class ErrorBoundary extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            hasError: false,
            error: null,
            isReporting: false // YENİ: Raporlama devam ediyor mu?
        };
    }

    static getDerivedStateFromError(error) {
        return { hasError: true, error };
    }


    async componentDidCatch(error, errorInfo) {

        if (this.state.isReporting) return; // Zaten raporluyorsa dur
        this.setState({ isReporting: true });

        const sessionUser = getUser();
        const userId = sessionUser?.UserId || 0;
        const errorLocation = window?.location?.pathname;
        let originalLocation = "Orijinal konum tespit edilemedi";

        try {
            const stackTrace = error?.stack || "";
            // Daha kapsayıcı bir Regex: URL:SATIR:SUTUN yapısını yakalar
            const stackLines = stackTrace.split("\n");

            const callerLine = stackLines.find(line =>
                line.includes('.js:') &&
                !line.includes('ErrorBoundary') &&
                !line.includes('node_modules')
            );


            const match = callerLine?.match(/(?:\()?(.*\.js):(\d+):(\d+)\)?/);

            if (match) {
                const [ scriptUrl, line, column] = match;
                // Dosya adını her ihtimale karşı saklayalım
                const fileNameOnly = scriptUrl.split('/').pop();
                try {
                    const mapResponse = await fetch(`${scriptUrl}.map`);
                    const contentType = mapResponse.headers.get("content-type");

                    if (mapResponse.ok && contentType?.includes("application/json")) {
                        const rawSourceMap = await mapResponse.json();


                        const consumer = await new sourceMap.SourceMapConsumer(rawSourceMap);
                        const original = consumer.originalPositionFor({
                            line: parseInt(line, 10),
                            column: parseInt(column, 10)
                        });
                        consumer.destroy();


                        if (original.source) {
                            originalLocation = `DOSYA: ${original.source} | SATIR: ${original.line}:${original.column} | FONKSİYON: ${original.name || 'Bilinmiyor'}`;
                        }
                    } else {
                        // .map bulunamazsa ham bilgiyi yazalım
                        originalLocation = `CHUNK: ${fileNameOnly} | HAM SATIR: ${line}:${column} (SourceMap Bulunamadı)`;
                    }
                } catch (innerError) {
                    originalLocation = `CHUNK: ${fileNameOnly} | HAM SATIR: ${line}:${column} (Çözümleme Hatası: ${innerError.message})`;
                }
            }
        } catch (e) {
            logger.error("SourceMap Error:", e);
            originalLocation = "Çözümleme sırasında hata: " + e.message;
        }

        const requestParam = {
            category: error?.name || "React Render Error",
            rating: -13,
            description: `
YENİSAYFA: ${errorLocation}
GERÇEK HATA YERİ: ${originalLocation}
MESAJ: ${error?.message}
--- BİLEŞEN YIĞINI ---
${errorInfo?.componentStack}
--- TEKNİK STACK ---
${error?.stack}
        `.trim(),
            imageBase64: '',
            fileName: "React_ErrorBoundary",
            ServiceShopId: 0,
            UserId: userId || '0'
        };

        try {
            await axios.post('/SetTechnicianFeedback', requestParam);

        } catch (apiError) {
            logger.error("Kritik: Hata raporlanamadı.");
        } finally {
            this.setState({ isReporting: false });
        }
    }

    componentDidMount() {
        // ErrorBoundary dışındaki asenkron hataları (Promise) yakalar
        window.addEventListener('unhandledrejection', this.handleGlobalRejection);
    }

    componentWillUnmount() {
        window.removeEventListener('unhandledrejection', this.handleGlobalRejection);
    }

    handleGlobalRejection = (event) => {
        // event.reason bazen bir Error nesnesidir, bazen sadece bir stringdir.
        const error = event.reason instanceof Error ? event.reason : new Error(event.reason);
        const message = error?.message || "";
        const errorName = error?.name || "";

        // Kamera, mikrofon, konum izin hatalarını raporlama - bunlar beklenen davranışlar
        const isMediaOrPermissionError = 
            message.includes("audio device") || 
            message.includes("camera") || 
            message.includes("Camera") ||
            message.includes("TrackStartError") ||
            message.includes("NotReadableError") ||
            message.includes("Could not start video source") ||
            message.includes("Could not initialize camera") ||
            message.includes("initialize camera") ||
            message.includes("Track is in an invalid state") ||
            message.includes("invalid state") ||
            message.includes("Permission denied") ||
            message.includes("Permission dismissed") ||
            message.includes("user denied permission") ||
            message.includes("not allowed by the user agent") ||
            message.includes("denied permission") ||
            errorName === "NotReadableError" ||
            errorName === "NotFoundError" ||
            errorName === "NotAllowedError" ||
            errorName === "OverconstrainedError" ||
            errorName === "OperationError" ||
            errorName === "PermissionDeniedError" ||
            errorName === "GeolocationPositionError";

        // Medya/izin hataları için raporlama yapma
        if (isMediaOrPermissionError) {
            return;
        }

        // Orijinal hatanın stack bilgisini koruyarak gönderiyoruz
        this.componentDidCatch(error, {
            componentStack: 'Global Promise Rejection (Asenkron Hata)'
        });
    };
    // Sıfırlama, Versiyon Güncelleme ve Yenileme Fonksiyonu
    handleResetAndReload = async () => {
        try {
            // 1. LocalStorage ve SessionStorage Temizle
            localStorage.clear();
            sessionStorage.clear();

            // 2. Cache Storage (Önbellek) Temizle - Eski dosyaları siler
            if ('caches' in window) {
                const cacheNames = await caches.keys();
                await Promise.all(
                    cacheNames.map(name => caches.delete(name))
                );
            }

            // 3. Service Worker Güncelleme ve Yeni Versiyonu Zorlama
            if ('serviceWorker' in navigator) {
                const registrations = await navigator.serviceWorker.getRegistrations();
                for (let registration of registrations) {
                    // Yeni bir versiyon varsa kontrol et
                    await registration.update();

                    // Mevcut çalışan Service Worker'ı devreden çıkar (Unregister)
                    // Bu sayede sayfa yenilendiğinde tarayıcı en güncel SW dosyasını çekmek zorunda kalır.
                    await registration.unregister();
                }
            }

            // 4. IndexedDB Temizleme (Eğer uygulamanız kullanıyorsa)
            // Bazı büyük PWA verileri burada tutulur.
            if (window.indexedDB && window.indexedDB.databases) {
                const dbs = await window.indexedDB.databases();
                dbs.forEach(db => {
                    window.indexedDB.deleteDatabase(db.name);
                });
            }

            // 5. Hard Reload (Sunucudan en güncel dosyaları çekmeye zorlar)
            // window.location.reload(true) artık çoğu modern tarayıcıda standart dışıdır.
            // Bu yüzden timestamp ekleyerek yönlendirme yapmak cache-busting sağlar.
            const url = new URL(window.location.origin);
            url.searchParams.set('v', Date.now()); // Query string ekleyerek cache'i atlatıyoruz
            window.location.href = url.href;

        } catch (err) {
            logger.error("Sıfırlama ve güncelleme hatası:", err);
            window.location.href = "/"; // Hata olursa ana dizine dön
        }
    };

    render() {
        if (this.state.hasError) {
            return (
                <div style={{
                    display: 'flex',
                    justifyContent: 'center',
                    alignItems: 'center',
                    minHeight: '80vh',
                    padding: '20px'
                }}>
                    <Card style={{ maxWidth: 500, boxShadow: '0px 4px 20px rgba(0,0,0,0.1)' }}>
                        <CardHeader
                            title="Sistem Kesintisi"
                            subheader="Bağlantı veya Veri Hatası"
                            titleTypographyProps={{ variant: 'h5', style: { fontWeight: 'bold', color: '#424242' } }}
                            style={{ backgroundColor: '#f5f5f5', borderBottom: '1px solid #e0e0e0' }}
                        />
                        <CardContent style={{ textAlign: 'center', padding: '30px 20px' }}>
                            <div style={{ fontSize: '50px', marginBottom: '10px' }}><span role="img" aria-label="uyarı">⚠️</span></div>
                            <Typography variant="h6" gutterBottom style={{ color: '#d32f2f', fontWeight: 'bold' }}>
                                İşlem Devam Edemiyor
                            </Typography>
                            <Typography variant="body2" color="textSecondary" align="left" style={{ marginTop: '15px', lineHeight: '1.6' }}>
                                Uygulama verileri temizlenerek sistem yeniden başlatılacaktır.
                            </Typography>

                            <div style={{
                                backgroundColor: '#fff3e0',
                                padding: '12px',
                                borderRadius: '4px',
                                marginTop: '15px',
                                borderLeft: '5px solid #ff9800'
                            }}>
                                <Typography variant="body2" style={{ color: '#e65100', fontWeight: '500' }}>
                                    <b>Uyarı:</b> Bu işlem tüm oturum verilerini ve kaydedilmemiş değişiklikleri silecektir.
                                </Typography>
                            </div>
                        </CardContent>
                        <Divider />
                        <CardActions style={{ padding: '16px' }}>
                            <Button
                                variant="contained"
                                onClick={this.handleResetAndReload} // Yeni fonksiyon bağlandı
                                fullWidth
                                style={{
                                    backgroundColor: '#424242',
                                    color: '#FF9800',
                                    fontWeight: 'bold',
                                    padding: '10px',
                                    fontSize: '1rem'
                                }}
                            >
                                VERİLERİ SIFIRLA VE YENİDEN BAŞLAT
                            </Button>
                        </CardActions>
                    </Card>
                </div>
            );
        }

        return this.props.children;
    }
}

export default ErrorBoundary;